import { cn } from '@jeraisonne/ui';
import { formatFeedBadge } from '@/lib/news/feed-unread';

/**
 * Pastille de compteur sur un item de navigation (ex. nouveautés du Feed).
 * - `inline` : à droite du libellé (menu latéral) ;
 * - `icon` : posée sur le coin de l'icône (barre du bas) — le parent de
 *   l'icône doit être `relative`.
 * Rien n'est rendu à 0.
 */
export function NavBadge({
  count,
  variant = 'inline',
  className,
}: {
  count: number;
  variant?: 'inline' | 'icon';
  className?: string;
}) {
  const text = formatFeedBadge(count);
  if (!text) return null;
  return (
    <span
      aria-label={`${count} nouveauté${count > 1 ? 's' : ''}`}
      className={cn(
        'bg-accent-400 light:bg-[#ef4444] light:text-white inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 font-sans text-xs font-bold leading-none text-[#0a2e57]',
        variant === 'inline' && 'ml-auto',
        variant === 'icon' &&
          'light:shadow-[0_0_0_2px_#ffffff] absolute -right-2.5 -top-1.5 shadow-[0_0_0_2px_rgba(8,42,92,0.9)]',
        className,
      )}
    >
      {text}
    </span>
  );
}
